
import Vue from "vue";
import config from "@/config";

export default Vue.extend({
  name: "GeoViz",

  data() {
    return {
      loading: true,
      loadError: false,
      loadAttempt: 0,
    };
  },

  computed: {
    /**
     * GeoViz is served as static files from tempstars-api at /geoviz/.
     * The admin JWT is passed via URL hash so the React app can authenticate
     * API calls. Hash fragments are never sent to the server.
     */
    geoVizUrl(): string {
      const base = (config as any).api_url || "http://localhost:10000/";
      const baseUrl = `${base.replace(/\/$/, '')}/geoviz/`;
      const jwt = localStorage.getItem("jwt") || "";
      return jwt ? `${baseUrl}#token=${encodeURIComponent(jwt)}` : baseUrl;
    },
  },

  mounted() {
    // Probe the geo-viz URL before showing the iframe so we can give a clear
    // error message if the app isn't running, rather than a blank frame.
    this.probeGeoViz();
  },

  methods: {
    async probeGeoViz(): Promise<void> {
      try {
        // fetch with no-cors so we don't get CORS errors — we only care about
        // whether the server is up, not about reading the response body.
        await fetch(this.geoVizUrl, { mode: "no-cors", cache: "no-store" });
        // If we get here the server responded (opaque response counts as success)
        this.loading = false;
        this.loadError = false;
      } catch {
        this.loading = false;
        this.loadError = true;
      }
    },

    onFrameLoad(): void {
      this.loading = false;
      this.loadError = false;
    },

    onFrameError(): void {
      this.loading = false;
      this.loadError = true;
    },

    retryLoad(): void {
      this.loading = true;
      this.loadError = false;
      this.loadAttempt += 1;
      this.probeGeoViz();
    },
  },
});
